import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconMoneyAffirm, homefieldIconMoneyCash, homefieldIconMoneyCreditcardAmex, homefieldIconMoneyCreditcardDiscover, homefieldIconMoneyCreditcardMastercard, homefieldIconMoneyCreditcardPlcc, homefieldIconMoneyCreditcardScorerewards, homefieldIconMoneyCreditcardVisa } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaymentSummaryComponent } from './payment-summary.component';

@NgModule({
	declarations: [PaymentSummaryComponent],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule
	],
	exports: [
		PaymentSummaryComponent
	]
})
export class PaymentSummaryModule {

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {

		homefieldIconsLibraryService.registerIcons([homefieldIconMoneyCreditcardAmex,
			homefieldIconMoneyCreditcardDiscover,
			homefieldIconMoneyCreditcardVisa,
			homefieldIconMoneyCreditcardMastercard,
			homefieldIconMoneyCreditcardPlcc,
			homefieldIconMoneyCreditcardScorerewards,
			homefieldIconMoneyAffirm,
			homefieldIconMoneyCash
		 ]);

	}
}
